(() => {
  const slug = (value) => value
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '') || 'section';

  const addSupportNavigation = (root) => {
    const content = root.querySelector('.studio-support-page__content');
    const rail = root.querySelector('.studio-support-page__rail');
    const navigation = root.querySelector('[data-studio-support-nav]');
    if (!content || !rail || !navigation || navigation.dataset.enhanced === 'true') return;

    const headings = [...content.querySelectorAll('h2, h3')].filter((heading) => heading.textContent.trim());
    navigation.dataset.enhanced = 'true';

    if (!headings.length) {
      rail.hidden = true;
      return;
    }

    const usedIds = new Set([...document.querySelectorAll('[id]')].map((element) => element.id));
    headings.forEach((heading) => {
      if (!heading.id) {
        const baseId = `support-${slug(heading.textContent)}`;
        let headingId = baseId;
        let suffix = 2;
        while (usedIds.has(headingId)) {
          headingId = `${baseId}-${suffix}`;
          suffix += 1;
        }
        heading.id = headingId;
        usedIds.add(headingId);
      }

      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent.trim();
      link.dataset.supportLevel = heading.tagName.slice(1);
      navigation.append(link);
    });

    navigation.hidden = false;
    rail.hidden = false;
  };

  const initialize = (scope = document) => {
    const roots = scope.matches?.('[data-studio-support-page]')
      ? [scope]
      : scope.querySelectorAll?.('[data-studio-support-page]') || [];
    roots.forEach(addSupportNavigation);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize());
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
